import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Replaced react-icons with inline SVG icons for a self-contained component.
const FiSun = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>;
const FiMoon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>;
const FiGlobe = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>;
const FiMail = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>;
const FiGithub = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path></svg>;
const FiLinkedin = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2a2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>;
const FiMapPin = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>;
const FiPhone = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2.18A19.95 19.95 0 0 1 8.82 2H5a2 2 0 0 1-2-2.18A19.95 19.95 0 0 1 15.08 22h3a2 2 0 0 1 2.18-2.18l.78-3.03z"></path></svg>;
const FiMenu = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>;
const FiX = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>;
const FaVuejs = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-4xl text-vue-green"><path d="M12 21.35l-9.1-15.75h18.2zM21.1 5.6L12 21.35 2.9 5.6h18.2zM12 17.65l-6.1-10.5h12.2z" /></svg>;
const SiFlutter = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-4xl text-blue-400"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM12 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zM12 5c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zM12 13c-4.142 0-7.5 3.358-7.5 7.5h15c0-4.142-3.358-7.5-7.5-7.5z" /></svg>;
const SiJavascript = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-4xl text-yellow-400"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM12 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zM12 10.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5z" /></svg>;
const SiHtml5 = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-4xl text-orange-500"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM12 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zM12 5c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zM12 13c-4.142 0-7.5 3.358-7.5 7.5h15c0-4.142 3.358-7.5-7.5-7.5z" /></svg>;
const SiCss3 = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-4xl text-blue-500"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM12 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zM12 13c-2.761 0-5-2.239-5-5s2.239-5 5-5 5 2.239 5 5-2.239 5-5 5zM12 15c4.142 0 7.5 3.358 7.5 7.5h-15c0-4.142 3.358-7.5-7.5-7.5z" /></svg>;
const SiBootstrap = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-4xl text-purple-500"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM12 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zM12 10.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5z" /></svg>;
const SiJquery = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-4xl text-blue-600"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM12 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zM12 13c-2.761 0-5-2.239-5-5s2.239-5 5-5 5 2.239 5 5-2.239 5-5 5zM12 15c4.142 0 7.5 3.358 7.5 7.5h-15c0-4.142 3.358-7.5-7.5-7.5z" /></svg>;
const SiGit = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-4xl text-orange-600"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM12 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zM12 10.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5z" /></svg>;
const FaFigma = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-4xl text-purple-400"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM12 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zM12 10.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5z" /></svg>;
const FaAdobe = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-4xl text-pink-500"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM12 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zM12 10.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5z" /></svg>;
const FiLoader = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="animate-spin"><path d="M21 12a9 9 0 1 1-6.219-8.56"></path></svg>;

// --- Data based on your CV ---
const portfolioData = {
  en: {
    name: "Kinan Abdalrazak",
    title: "Front-End & Mobile App Developer",
    intro: "A passionate Software Engineer with 3+ years of experience in building responsive web and mobile applications. I specialize in Vue.js and Flutter, with a keen eye for UI/UX design.",
    cta1: "View Projects",
    cta2: "Contact Me",
    aboutTitle: "About Me",
    aboutText: "I am a Front-End Web Developer with a proven track record of creating and maintaining scalable applications. My journey in tech is driven by a passion for solving complex problems and a commitment to continuous learning. With a background in mobile development using Flutter and UI/UX design with tools like Figma, I bring a holistic approach to building digital products that are both functional and beautiful. I thrive in collaborative environments and am always eager to take on new challenges.",
    skillsTitle: "Skills",
    projectsTitle: "Projects",
    experienceTitle: "Experience & Education",
    certificationsTitle: "Certifications",
    contactTitle: "Get In Touch",
    location: "Damascus, Syria",
    phone: "+963 988 264 670",
    email: "kinanabdalrzzak@gmail.com",
    contactForm: {
      name: "Your Name",
      email: "Your Email",
      message: "Your Message",
      send: "Send Message",
      sending: "Sending...",
      success: "Message sent!",
      error: "Failed to send."
    },
    skills: {
      frontend: [
        { name: "Vue.js", icon: <FaVuejs /> },
        { name: "Flutter", icon: <SiFlutter /> },
        { name: "JavaScript", icon: <SiJavascript /> },
        { name: "HTML5", icon: <SiHtml5 /> },
        { name: "CSS3", icon: <SiCss3 /> },
        { name: "Bootstrap", icon: <SiBootstrap /> },
        { name: "jQuery", icon: <SiJquery /> },
      ],
      other: [
        { name: "Git", icon: <SiGit /> },
        { name: "Figma", icon: <FaFigma /> },
        { name: "Adobe XD", icon: <FaAdobe /> },
      ]
    },
    projects: [
      {
        title: "ERP System Modules",
        description: "Developed and maintained various ERP modules using Vue.js, including Accounting, Inventory, HR, and more for Incentive.",
        image: "https://placehold.co/600x400/34495e/ffffff?text=ERP+System",
        tags: ["Vue.js", "ERP", "Frontend"]
      },
      {
        title: "Happy Shop App",
        description: "A smart food discount mobile app built with Flutter, designed to reduce food waste by offering deals on items nearing their expiration date.",
        image: "https://placehold.co/600x400/34495e/ffffff?text=Happy+Shop",
        tags: ["Flutter", "Mobile App", "UI/UX"]
      },
      {
        title: "Medical System App",
        description: "An integrated Flutter platform connecting clinics, labs, and pharmacies, allowing patients to manage appointments seamlessly.",
        image: "https://placehold.co/600x400/34495e/ffffff?text=Medical+System",
        tags: ["Flutter", "Healthcare", "Mobile"]
      },
      {
        title: "University Management System",
        description: "A comprehensive system for students to manage requests, objections, and view marks, with automated PDF generation. Built with Flutter.",
        image: "https://placehold.co/600x400/34495e/ffffff?text=University+System",
        tags: ["Flutter", "Education", "Automation"]
      }
    ],
    timeline: [
      {
        type: "work",
        title: "Web Developer",
        subtitle: "Incentive – Damascus",
        date: "Oct 2022 – Present",
        description: "Developed and maintained ERP modules using Vue.js, collaborating with cross-functional teams to improve system performance and usability."
      },
      {
        type: "education",
        title: "Bachelor's in Computer Science",
        subtitle: "Damascus University",
        date: "Graduated 2023",
        description: "Completed a comprehensive degree in Computer Science & Information Technology, building a strong foundation in software engineering principles."
      },
      {
        type: "work",
        title: "Mobile App Developer",
        subtitle: "MAK Tech – Damascus",
        date: "Feb 2021 – Sept 2022",
        description: "Built cross-platform mobile applications with Flutter for various sectors including retail, healthcare, and education."
      },
      {
        type: "work",
        title: "Technical Support (Freelance)",
        subtitle: "Self-employed",
        date: "Aug 2020 – Dec 2020",
        description: "Designed and managed network infrastructure for hotels and monitoring systems for gyms."
      },
    ],
    certifications: [
      "Web & Android Developer",
      "MCSA Windows Server 2016",
      "CCNA",
      "Technical Support – IECD",
      "Computer Maintenance – IECD",
      "Mobile Maintenance – Syria Trust",
      "ICDL",
      "NLP & Life Skills"
    ]
  },
  ar: {
    name: "كنان عبدالرزاق",
    title: "مطور واجهات أمامية وتطبيقات جوال",
    intro: "مهندس برمجيات شغوف بخبرة تزيد عن 3 سنوات في بناء تطبيقات الويب والجوال سريعة الاستجابة. متخصص في Vue.js و Flutter، مع اهتمام كبير بتصميم واجهة المستخدم وتجربة المستخدم.",
    cta1: "شاهد المشاريع",
    cta2: "تواصل معي",
    aboutTitle: "عني",
    aboutText: "أنا مطور واجهات أمامية للويب ولدي سجل حافل في إنشاء وصيانة التطبيقات القابلة للتطوير. شغفي بحل المشكلات المعقدة والتزامي بالتعلم المستمر هو ما يدفع رحلتي في مجال التكنولوجيا. بخلفية في تطوير تطبيقات الجوال باستخدام Flutter وتصميم واجهة المستخدم / تجربة المستخدم بأدوات مثل Figma، أقدم نهجًا شموليًا لبناء منتجات رقمية وظيفية وجميلة. أزدهر في البيئات التعاونية وأنا دائمًا حريص على مواجهة تحديات جديدة.",
    skillsTitle: "المهارات",
    projectsTitle: "المشاريع",
    experienceTitle: "الخبرة والتعليم",
    certificationsTitle: "الشهادات",
    contactTitle: "تواصل معي",
    location: "دمشق، سوريا",
    phone: "+963 988 264 670",
    email: "kinanabdalrzzak@gmail.com",
    contactForm: {
      name: "اسمك",
      email: "بريدك الإلكتروني",
      message: "رسالتك",
      send: "إرسال الرسالة",
      sending: "يتم الإرسال...",
      success: "تم إرسال الرسالة!",
      error: "فشل الإرسال."
    },
    skills: {
      frontend: [
        { name: "Vue.js", icon: <FaVuejs /> },
        { name: "Flutter", icon: <SiFlutter /> },
        { name: "JavaScript", icon: <SiJavascript /> },
        { name: "HTML5", icon: <SiHtml5 /> },
        { name: "CSS3", icon: <SiCss3 /> },
        { name: "Bootstrap", icon: <SiBootstrap /> },
        { name: "jQuery", icon: <SiJquery /> },
      ],
      other: [
        { name: "Git", icon: <SiGit /> },
        { name: "Figma", icon: <FaFigma /> },
        { name: "Adobe XD", icon: <FaAdobe /> },
      ]
    },
    projects: [
      {
        title: "وحدات نظام تخطيط موارد المؤسسات",
        description: "قمت بتطوير وصيانة وحدات مختلفة لنظام تخطيط موارد المؤسسات باستخدام Vue.js، بما في ذلك المحاسبة والمخزون والموارد البشرية وغيرها لشركة Incentive.",
        image: "https://placehold.co/600x400/34495e/ffffff?text=ERP+System",
        tags: ["Vue.js", "ERP", "Frontend"]
      },
      {
        title: "تطبيق Happy Shop",
        description: "تطبيق جوال ذكي لخصومات الطعام تم بناؤه باستخدام Flutter، مصمم لتقليل هدر الطعام من خلال تقديم عروض على المنتجات التي تقترب من تاريخ انتهاء صلاحيتها.",
        image: "https://placehold.co/600x400/34495e/ffffff?text=Happy+Shop",
        tags: ["Flutter", "تطبيق جوال", "UI/UX"]
      },
      {
        title: "تطبيق النظام الطبي",
        description: "منصة متكاملة باستخدام Flutter تربط بين العيادات والمختبرات والصيدليات، مما يسمح للمرضى بإدارة المواعيد بسلاسة.",
        image: "https://placehold.co/600x400/34495e/ffffff?text=Medical+System",
        tags: ["Flutter", "رعاية صحية", "جوال"]
      },
      {
        title: "نظام إدارة الجامعة",
        description: "نظام شامل للطلاب لإدارة الطلبات والاعتراضات وعرض العلامات، مع إنشاء ملفات PDF تلقائيًا. تم بناؤه باستخدام Flutter.",
        image: "https://placehold.co/600x400/34495e/ffffff?text=University+System",
        tags: ["Flutter", "تعليم", "أتمتة"]
      }
    ],
    timeline: [
      {
        type: "work",
        title: "مطور ويب",
        subtitle: "Incentive – دمشق",
        date: "أكتوبر 2022 – حتى الآن",
        description: "قمت بتطوير وصيانة وحدات نظام تخطيط موارد المؤسسات باستخدام Vue.js، بالتعاون مع فرق متعددة الوظائف لتحسين أداء النظام وسهولة استخدامه."
      },
      {
        type: "education",
        title: "بكالوريوس في علوم الحاسوب",
        subtitle: "جامعة دمشق",
        date: "تخرج 2023",
        description: "أكملت درجة علمية شاملة في علوم الحاسوب وتكنولوجيا المعلومات، مما بنى أساسًا قويًا في مبادئ هندسة البرمجيات."
      },
      {
        type: "work",
        title: "مطور تطبيقات جوال",
        subtitle: "MAK Tech – دمشق",
        date: "فبراير 2021 – سبتمبر 2022",
        description: "قمت ببناء تطبيقات جوال متعددة المنصات باستخدام Flutter لقطاعات مختلفة بما في ذلك البيع بالتجزئة والرعاية الصحية والتعليم."
      },
      {
        type: "work",
        title: "دعم فني (مستقل)",
        subtitle: "عمل حر",
        date: "أغسطس 2020 – ديسمبر 2020",
        description: "قمت بتصميم وإدارة البنية التحتية للشبكات للفنادق وأنظمة المراقبة للصالات الرياضية."
      },
    ],
    certifications: [
      "مطور ويب وأندرويد",
      "MCSA Windows Server 2016",
      "CCNA",
      "دعم فني – IECD",
      "صيانة حاسوب – IECD",
      "صيانة جوال – Syria Trust",
      "ICDL",
      "برمجة لغوية عصبية ومهارات حياتية"
    ]
  }
};

// --- Animation Variants ---
const sectionVariant = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};

// --- Reusable Components ---
const Section = ({ id, children, className = '' }) => (
  <motion.section
    id={id}
    className={`py-20 px-4 sm:px-6 lg:px-8 w-full ${className}`}
    variants={sectionVariant}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
  >
    <div className="max-w-7xl mx-auto">{children}</div>
  </motion.section>
);

const SectionTitle = ({ children, lang }) => (
  <h2 className={`text-4xl font-bold text-center mb-12 ${lang === 'ar' ? 'font-cairo' : 'font-sans'} text-gray-800 dark:text-gray-100`}>
    {children}
  </h2>
);

const Card = ({ children, className = '' }) => (
    <motion.div
      className={`bg-white dark:bg-gray-800 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 overflow-hidden ${className}`}
      whileHover={{ y: -5, transition: { duration: 0.2 } }}
    >
      {children}
    </motion.div>
);

// --- App Components ---
const Header = ({ theme, toggleTheme, lang, toggleLang }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [
    { id: 'about', en: 'About', ar: 'عني' },
    { id: 'skills', en: 'Skills', ar: 'المهارات' },
    { id: 'projects', en: 'Projects', ar: 'المشاريع' },
    { id: 'experience', en: 'Experience', ar: 'الخبرة' },
    { id: 'contact', en: 'Contact', ar: 'تواصل' },
  ];

  return (
<motion.header
  className="bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm fixed top-0 left-0 right-0 z-50 shadow-md"
  initial={{ y: -100 }}
  animate={{ y: 0 }}
  transition={{ duration: 0.5, ease: 'easeOut' }}
>
  <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
    <a
      href="#hero"
      className="text-2xl font-bold text-vue-green hover:scale-110 transition-transform"
    >
      KA
    </a>

    {/* Desktop Links */}
    <div className="hidden md:flex items-center space-x-6">
      {navLinks.map((link) => (
        <a
          key={link.id}
          href={`#${link.id}`}
          className={`text-gray-600 dark:text-gray-300 hover:text-vue-green dark:hover:text-vue-green transition-colors duration-300 ${
            lang === "ar" ? "font-cairo" : ""
          }`}
        >
          {link[lang]}
        </a>
      ))}
    </div>

    {/* Right Section */}
    <div className="flex items-center space-x-4">
      {/* Download CV Button */}
      <motion.a
        href="/KinanAbdalrazakCV.pdf" // ضع مسار ملف CV هنا داخل public folder
        download
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="bg-vue-green text-white px-4 py-2 rounded-lg shadow hover:bg-green-600 transition-colors text-sm font-semibold"
      >
        {lang === "en" ? "Download CV" : "تحميل السيرة"}
      </motion.a>

      {/* Theme Toggle */}
      <motion.button
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.9 }}
        onClick={toggleTheme}
        className="text-gray-600 dark:text-gray-300 focus:outline-none"
      >
        {theme === "dark" ? <FiSun size={20} /> : <FiMoon size={20} />}
      </motion.button>

      {/* Language Toggle */}
      <motion.button
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.9 }}
        onClick={toggleLang}
        className="text-gray-600 dark:text-gray-300 focus:outline-none flex items-center"
      >
        <FiGlobe size={20} />
        <span className="ml-2 text-sm font-semibold">
          {lang === "en" ? "AR" : "EN"}
        </span>
      </motion.button>

      {/* Mobile Menu Button */}
      <div className="md:hidden">
        <motion.button
          whileTap={{ scale: 0.9 }}
          onClick={() => setIsOpen(!isOpen)}
          className="text-gray-600 dark:text-gray-300 focus:outline-none"
        >
          {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </motion.button>
      </div>
    </div>
  </nav>

  {/* Mobile Menu */}
  <AnimatePresence>
    {isOpen && (
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: "auto" }}
        exit={{ opacity: 0, height: 0 }}
        className="md:hidden bg-white/95 dark:bg-gray-900/95"
      >
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 flex flex-col items-center">
          {navLinks.map((link, i) => (
            <motion.a
              key={link.id}
              href={`#${link.id}`}
              onClick={() => setIsOpen(false)}
              className={`block px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-vue-green dark:hover:text-vue-green ${
                lang === "ar" ? "font-cairo" : ""
              }`}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
            >
              {link[lang]}
            </motion.a>
          ))}

          {/* Download CV button in mobile menu */}
          <motion.a
            href="/KinanAbdalrazakCV.pdf"
            download
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="mt-3 bg-vue-green text-white px-4 py-2 rounded-lg shadow hover:bg-green-600 transition-colors text-sm font-semibold"
          >
            {lang === "en" ? "Download CV" : "تحميل السيرة"}
          </motion.a>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
</motion.header>

  );
};

const Hero = ({ content, lang }) => (
  <section id="hero" className="min-h-screen flex items-center bg-gray-50 dark:bg-gray-900">
    <div className={`container mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-12 text-center md:text-left ${lang === 'ar' ? 'md:flex-row-reverse' : ''}`}>
        {/* Diamond Shaped Image Container */}
    <motion.div
      className="w-80 h-80 md:w-[28rem] md:h-[28rem] relative"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, type: "spring" }}
    >
      {/* الإطار الأبيض */}
      <div
        className="absolute inset-0 bg-white"
        style={{
          clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)", // شكل معين
        }}
      ></div>

      {/* الصورة جوّا المعين أصغر بشوي ليبين الإطار */}
      <div
        className="absolute inset-2 bg-black overflow-hidden shadow-2xl"
        style={{
          clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)", // نفس المعين
        }}
      >
        <img
          src="https://placehold.co/400x400/41B883/ffffff?text=KA"
          alt="Kinan Abdalrazak"
          className="w-full h-full object-cover"
        />
      </div>
    </motion.div>
        {/* Text Content */}
        <motion.div
            className={`flex flex-col items-center md:items-start ${lang === 'ar' ? 'text-right' : 'text-left'}`}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
        >
            <h1 className={`text-5xl md:text-7xl font-extrabold text-gray-800 dark:text-white mb-4 ${lang === 'ar' ? 'font-cairo' : ''}`}>
                {content.name}
            </h1>
            <p className={`text-xl md:text-2xl text-vue-green font-semibold mb-6 ${lang === 'ar' ? 'font-cairo' : ''}`}>
                {content.title}
            </p>
            <p className={`max-w-2xl text-gray-600 dark:text-gray-300 mb-10 ${lang === 'ar' ? 'font-cairo' : ''}`}>
                {content.intro}
            </p>
            <motion.div
                className={`flex space-x-4 ${lang === 'ar' ? 'flex-row-reverse space-x-reverse' : ''}`}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
            >
                <motion.a whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} href="#projects" className="px-8 py-3 bg-vue-green text-white font-bold rounded-full hover:bg-green-600 transition-colors duration-300 shadow-lg">
                    {content.cta1}
                </motion.a>
                <motion.a whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} href="#contact" className="px-8 py-3 bg-gray-700 text-white font-bold rounded-full hover:bg-gray-800 transition-colors duration-300 shadow-lg">
                    {content.cta2}
                </motion.a>
            </motion.div>
        </motion.div>
    </div>
  </section>
);

const About = ({ content, lang }) => (
  <Section id="about">
    <SectionTitle lang={lang}>{content.aboutTitle}</SectionTitle>
    <div className={`text-lg text-gray-700 dark:text-gray-300 leading-relaxed max-w-4xl mx-auto ${lang === 'ar' ? 'font-cairo text-right' : 'text-left'}`}>
      <p>{content.aboutText}</p>
    </div>
  </Section>
);

const Skills = ({ content, lang }) => (
  <Section id="skills" className="bg-gray-50 dark:bg-gray-900">
    <SectionTitle lang={lang}>{content.skillsTitle}</SectionTitle>
    <div className="space-y-12">
      <div>
        <h3 className={`text-2xl font-semibold text-center mb-8 text-gray-700 dark:text-gray-200 ${lang === 'ar' ? 'font-cairo' : ''}`}>Front-End & Mobile</h3>
        <div className="flex flex-wrap justify-center gap-8">
          {content.skills.frontend.map((skill, index) => (
            <motion.div
              key={index}
              className="flex flex-col items-center space-y-2 group"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="group-hover:scale-110 transition-transform duration-300">{skill.icon}</div>
              <span className="text-gray-600 dark:text-gray-300">{skill.name}</span>
            </motion.div>
          ))}
        </div>
      </div>
      <div>
        <h3 className={`text-2xl font-semibold text-center mb-8 text-gray-700 dark:text-gray-200 ${lang === 'ar' ? 'font-cairo' : ''}`}>Other Tools & Technologies</h3>
        <div className="flex flex-wrap justify-center gap-8">
          {content.skills.other.map((skill, index) => (
            <motion.div
              key={index}
              className="flex flex-col items-center space-y-2 group"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="group-hover:scale-110 transition-transform duration-300">{skill.icon}</div>
              <span className="text-gray-600 dark:text-gray-300">{skill.name}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </Section>
);

const Projects = ({ content, lang }) => (
  <Section id="projects">
    <SectionTitle lang={lang}>{content.projectsTitle}</SectionTitle>
    <div className="grid md:grid-cols-2 gap-8">
      {content.projects.map((project, index) => (
        <Card key={index} className="h-full flex flex-col">
          <img src={project.image} alt={project.title} className="w-full h-56 object-cover"/>
          <div className={`p-6 flex-grow flex flex-col ${lang === 'ar' ? 'text-right' : 'text-left'}`}>
            <h3 className={`text-2xl font-bold mb-2 text-gray-800 dark:text-white ${lang === 'ar' ? 'font-cairo' : ''}`}>{project.title}</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-4 flex-grow">{project.description}</p>
            <div className={`flex flex-wrap gap-2 mt-auto ${lang === 'ar' ? 'justify-end' : 'justify-start'}`}>
              {project.tags.map(tag => (
                <span key={tag} className="bg-vue-green/20 text-vue-green font-semibold px-2.5 py-0.5 rounded-full">{tag}</span>
              ))}
            </div>
          </div>
        </Card>
      ))}
    </div>
  </Section>
);

const Experience = ({ content, lang }) => (
    <Section id="experience" className="bg-gray-50 dark:bg-gray-900">
        <SectionTitle lang={lang}>{content.experienceTitle}</SectionTitle>
        <div className="relative max-w-2xl mx-auto">
            {/* The vertical line */}
            <div className="absolute left-0 md:left-1/2 w-1 h-full bg-gray-200 dark:bg-gray-700 transform md:-translate-x-1/2"></div>

            {content.timeline.map((item, index) => (
                <div key={index} className="mb-10 relative">
                    <div className="flex md:items-center">
                        {/* Dot on the timeline */}
                        <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-vue-green items-center justify-center text-white z-10">
                            {item.type === 'work' ? 'W' : 'E'}
                        </div>

                        {/* Card Content - alternating sides for desktop */}
                        <motion.div
                            className={`w-full md:w-1/2 p-4 bg-white dark:bg-gray-800 rounded-lg shadow-lg
                                ${index % 2 === 0 ? 'md:pr-12' : 'md:pl-12 md:ml-auto'}
                                ${lang === 'ar' ? 'font-cairo text-right' : ''}`
                            }
                            initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            <p className="text-sm text-vue-green mb-1">{item.date}</p>
                            <h3 className="text-xl font-bold text-gray-800 dark:text-white">{item.title}</h3>
                            <p className="text-gray-500 dark:text-gray-400 mb-2">{item.subtitle}</p>
                            <p className="text-gray-600 dark:text-gray-300 text-sm">{item.description}</p>
                        </motion.div>
                    </div>
                </div>
            ))}
        </div>
    </Section>
);


const Certifications = ({ content, lang }) => (
  <Section id="certifications">
    <SectionTitle lang={lang}>{content.certificationsTitle}</SectionTitle>
    <div className="flex flex-wrap justify-center gap-4">
      {content.certifications.map((cert, index) => (
        <motion.div
          key={index}
          className="bg-vue-green/20 text-vue-green font-semibold px-4 py-2 rounded-full shadow-md"
          initial={{ opacity: 0, scale: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, delay: index * 0.1, type: 'spring', stiffness: 200 }}
        >
          {cert}
        </motion.div>
      ))}
    </div>
  </Section>
);

const Contact = ({ content, lang }) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    const formData = new FormData(e.target);
    const name = formData.get('name');
    const email = formData.get('email');
    const message = formData.get('message');

    // **IMPORTANT:** THIS IS FOR DEMONSTRATION ONLY.
    // In a real-world application, you MUST use a server-side proxy
    // to handle the Telegram API call securely. Exposing your bot token
    // on the client-side is a major security risk.
    const botToken = "8409910812:AAEkU8fFtLGwWO_FgqWB5KVJ1ZECJcfIn8s"; // REPLACE WITH YOUR BOT TOKEN
    const chatId = "861965593";     // REPLACE WITH YOUR CHAT ID

    if (botToken === "YOUR_BOT_TOKEN" || chatId === "YOUR_CHAT_ID") {
      setStatus('error');
      setLoading(false);
      console.error("Please replace the YOUR_BOT_TOKEN and YOUR_CHAT_ID placeholders in the code.");
      return;
    }

    const telegramApiUrl = `https://api.telegram.org/bot${botToken}/sendMessage`;
    const text = `New message from portfolio contact form:\n\nName: ${name}\nEmail: ${email}\nMessage: ${message}`;

    try {
      const response = await fetch(telegramApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          chat_id: chatId,
          text: text,
        }),
      });

      if (response.ok) {
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error("Failed to send message:", error);
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Section id="contact" className="bg-gray-50 dark:bg-gray-900">
      <SectionTitle lang={lang}>{content.contactTitle}</SectionTitle>
      <div className="flex flex-col lg:flex-row gap-12">
        <motion.div
          className={`lg:w-1/2 ${lang === 'ar' ? 'font-cairo text-right' : 'text-left'}`}
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="sr-only">{content.contactForm.name}</label>
              <input type="text" name="name" id="name" placeholder={content.contactForm.name} className="w-full px-4 py-3 rounded-lg bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-vue-green transition" />
            </div>
            <div>
              <label htmlFor="email" className="sr-only">{content.contactForm.email}</label>
              <input type="email" name="email" id="email" placeholder={content.contactForm.email} className="w-full px-4 py-3 rounded-lg bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-vue-green transition" />
            </div>
            <div>
              <label htmlFor="message" className="sr-only">{content.contactForm.message}</label>
              <textarea name="message" id="message" rows="5" placeholder={content.contactForm.message} className="w-full px-4 py-3 rounded-lg bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-vue-green transition"></textarea>
            </div>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              type="submit"
              disabled={loading}
              className={`w-full px-6 py-3 bg-vue-green text-white font-bold rounded-lg transition-colors duration-300 shadow-lg flex items-center justify-center ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-green-600'}`}
            >
              {loading ? (
                <>
                  <FiLoader className="mr-2" />
                  {content.contactForm.sending}
                </>
              ) : (
                content.contactForm.send
              )}
            </motion.button>
            <AnimatePresence>
              {status && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  className={`mt-4 text-center text-sm font-semibold ${
                    status === 'success' ? 'text-green-500' : 'text-red-500'
                  }`}
                >
                  {status === 'success' ? content.contactForm.success : content.contactForm.error}
                </motion.div>
              )}
            </AnimatePresence>
          </form>
        </motion.div>
        <motion.div
          className={`lg:w-1/2 flex flex-col justify-center space-y-6 ${lang === 'ar' ? 'font-cairo items-end' : 'items-start'}`}
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <a href={`mailto:${content.email}`} className="flex items-center space-x-4 group">
            <FiMail className="text-vue-green group-hover:text-green-600 transition-colors" size={24} />
            <span className="text-lg text-gray-700 dark:text-gray-300 group-hover:text-vue-green transition-colors">{content.email}</span>
          </a>
          <div className="flex items-center space-x-4">
            <FiPhone className="text-vue-green" size={24} />
            <span className="text-lg text-gray-700 dark:text-gray-300">{content.phone}</span>
          </div>
          <div className="flex items-center space-x-4">
            <FiMapPin className="text-vue-green" size={24} />
            <span className="text-lg text-gray-700 dark:text-gray-300">{content.location}</span>
          </div>
          <div className="flex space-x-6 pt-4">
            <motion.a whileHover={{ scale: 1.2, y: -2 }} href="https://git.incentive-dev.com/kinan" target="_blank" rel="noopener noreferrer" className="text-gray-500 dark:text-gray-400 hover:text-vue-green"><FiGithub size={30} /></motion.a>
            <motion.a whileHover={{ scale: 1.2, y: -2 }} href="https://www.linkedin.com/in/kinan-abdalrazak/" target="_blank" rel="noopener noreferrer" className="text-gray-500 dark:text-gray-400 hover:text-vue-green"><FiLinkedin size={30} /></motion.a>
          </div>
        </motion.div>
      </div>
    </Section>
  );
};

const Footer = () => (
  <footer className="bg-gray-800 dark:bg-black text-white py-6">
    <div className="container mx-auto text-center">
      <p>&copy; {new Date().getFullYear()} Kinan Abdalrazak. All Rights Reserved.</p>
    </div>
  </footer>
);


export default function App() {
  // Sets the theme from localStorage or defaults to 'light'
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');
  // Sets the language and defaults to 'en'
  const [lang, setLang] = useState('ar');

  // Custom Tailwind colors for Vue.js
  const customColors = {
      'vue-green': '#41B883',
      'vue-dark-green': '#34495e',
  };

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove(theme === 'dark' ? 'light' : 'dark');
    root.classList.add(theme);
    localStorage.setItem('theme', theme);

    // Dynamic Tailwind class injection for custom colors
    const style = document.createElement('style');
    style.innerHTML = `
      .text-vue-green { color: ${customColors['vue-green']}; }
      .bg-vue-green { background-color: ${customColors['vue-green']}; }
      .hover\\:text-vue-green:hover { color: ${customColors['vue-green']}; }
      .hover\\:bg-vue-green:hover { background-color: ${customColors['vue-green']}; }
      .border-vue-green { border-color: ${customColors['vue-green']}; }
      .ring-vue-green { --tw-ring-color: ${customColors['vue-green']}; }
      .bg-vue-green\\/20 { background-color: rgba(65, 184, 131, 0.2); }
      .text-vue-green { color: #41B883; }
      .bg-vue-green { background-color: #41B883; }
      .hover\\:text-vue-green:hover { color: #41B883; }
      .border-vue-green { border-color: #41B883; }
      .ring-vue-green { --tw-ring-color: #41B883; }
      .bg-vue-green\\/20 { background-color: rgba(65, 184, 131, 0.2); }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };

  }, [theme]);
  
  // Effect to set document language and direction
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }, [lang]);

  // Function to toggle between light and dark themes
  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  // Function to toggle between English and Arabic
  const toggleLang = () => {
    setLang(prevLang => (prevLang === 'en' ? 'ar' : 'en'));
  };

  const content = portfolioData[lang];

  return (
    <div className="bg-white dark:bg-gray-900 transition-colors duration-500">
      <Header theme={theme} toggleTheme={toggleTheme} lang={lang} toggleLang={toggleLang} />
      <main>
        <Hero content={content} lang={lang} />
        <About content={content} lang={lang} />
        <Skills content={content} lang={lang} />
        <Projects content={content} lang={lang} />
        <Experience content={content} lang={lang} />
        <Certifications content={content} lang={lang} />
        <Contact content={content} lang={lang} />
      </main>
      <Footer />
    </div>
  );
}
